import { MyStatementDialog } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    login: true,
    dialog: {
      get title() {
        return t('My Statement');
      },
      class:
        'h-[700px] bg-layer3-card [&_.dialog-title]:!text-[18px] [&_.dialog-title]:!font-bold [&_.dialog-title]:!leading-[22px]',
    },
  },
};

export default MyStatementDialog;
